import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header.jsx';
import Footer from './components/layout/Footer.jsx';
import ScrollToTop from './components/ui/ScrollToTop.jsx';
import Home from './pages/Home.jsx';
import About from './pages/About.jsx';
import ServicePage from './pages/ServicePage.jsx';
import Turistkoersel from './pages/Turistkoersel.jsx';
import Taxa from './pages/Taxa.jsx';
import TaxaPriser from './pages/TaxaPriser.jsx';
import Contact from './pages/Contact.jsx';
import MorsoeTuristfart from './pages/MorsoeTuristfart.jsx';

function App() {
  return (
    <div className="min-h-screen bg-white font-sans text-slate-900 antialiased">
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/ydelser/turist" element={<Turistkoersel />} />
          <Route path="/taxa" element={<Taxa />} />
          <Route path="/taxa/taxa-priser" element={<TaxaPriser />} />
          <Route path="/morsoe-turistfart" element={<MorsoeTuristfart />} />
          <Route path="/ydelser/:id" element={<ServicePage />} />
          <Route path="/kontakt" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
